import axios, { AxiosInstance } from "axios";
import { HTTPError } from "../../domain/errors/HTTPError";

export class AxiosHTTPCoreBaseRepository {
  protected readonly axiosInstance: AxiosInstance;

  constructor(baseURL: string, timeout: number) {
    this.axiosInstance = axios.create({
      baseURL,
      timeout,
    });
    this.axiosInstance.interceptors.response.use(
      (resp) => resp,
      (error) => {
        throw HTTPError.fromAxiosError(error);
      },
    );
  }
}
